import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { IconButton } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { ProductEntity } from 'src/entities/ProductEntity';
import { dataGridUtil } from 'src/utils/dataGrid.util';

export const Columns: (
  openEditDialog?: (productEntity: ProductEntity) => void
) => GridColDef[] = (
  openEditDialog
) => {
  const getWidth = (name: string, width: number) => {
    const maybeWidth: number = dataGridUtil.getSavedColumnWidth('product-columns', name);

    return maybeWidth || width;
  };

  const editColumn: GridColDef | null = openEditDialog ? {
    field: 'edit',
    headerName: '編集',
    disableExport: true,
    renderCell: (params: { row: ProductEntity }) => (
      <IconButton onClick={() => openEditDialog(params.row)}>
        <EditOutlinedIcon />
      </IconButton>
    ),
    width: 70,
    sortable: false,
    filterable: false,
  } : null;

  return [
    editColumn,
    {
      field: 'companyName',
      headerName: '事業所',
      width: getWidth('companyName', 200),
    },
    {
      field: 'code',
      headerName: '商品コード',
      width: getWidth('code', 150),
    },
    {
      field: 'name',
      headerName: '商品名',
      width: getWidth('name', 250),
    },
    {
      field: 'packingStyle',
      headerName: '荷姿',
      width: getWidth('packingStyle', 150),
    },
    {
      field: 'weightKgPerUnit',
      headerName: '単位重量(kg)',
      width: getWidth('weightKgPerUnit', 150),
      type: 'number',
    },
    {
      field: 'volumeM3PerUnit',
      headerName: '単位体積(m3)',
      width: getWidth('volumeM3PerUnit', 160),
      type: 'number',
    },
  ];
};
